import {
  Box,
  Flex,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Grid,
} from '@chakra-ui/react';
import { Change } from '@texas/api/endpoints/trackerApi';
import {
  stretchAnimation,
  scaleInAnimation,
} from '@texas/resources/animations/animations';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getTrackedChangeFriendlyName } from './translations';
import { dateFromNow } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';

interface Props {
  hasChanged: boolean;
  changes: Change[];
  children: React.ReactNode;
}

export function TrackerChanges({ hasChanged, children, changes }: Props) {
  return (
    <Box pos="relative" maxW="fit-content">
      {children}
      {hasChanged && (
        <Box pos="absolute" top={0} right={0} data-changed="1">
          <Popover trigger="hover" variant="tooltip">
            <PopoverTrigger>
              <Box
                borderRadius="50%"
                backgroundColor="texas.notification.info"
                boxSize={2}
                animation={`${stretchAnimation()},${scaleInAnimation()}`}
              />
            </PopoverTrigger>
            <PrintChanges changes={changes} />
          </Popover>
        </Box>
      )}
    </Box>
  );
}

function PrintChanges({ changes }: { changes: Change[] }) {
  const { t } = useTranslation();
  return (
    <PopoverContent>
      <PopoverBody>
        <Grid templateColumns="repeat(2, auto)" columnGap={3} w="fit-content">
          {changes.map((x, i) => (
            <Fragment key={i}>
              <Text variant="sub">{dateFromNow(Locale.EnDate, x.date)}</Text>
              <Flex gap={1}>
                <Text>{x.userName}:</Text>
                <Text>{getTrackedChangeFriendlyName(x, t)}</Text>
              </Flex>
            </Fragment>
          ))}
        </Grid>
      </PopoverBody>
    </PopoverContent>
  );
}
